import { useState } from "react";

/** Shared prefix for email-builder DOM ids (React 17 so there's no built-in useId). */
export const EMAIL_BUILDER_DOM_ID_PREFIX = "email-builder";

export function useStableDomId(prefix: string): string {
  const [id] = useState(() => `${prefix}-${crypto.randomUUID()}`);
  return id;
}

export function useStableScopedDomId(prefix: string, scope: string): string {
  const [id] = useState(() => `${prefix}-${scope}-${crypto.randomUUID()}`);
  return id;
}
